import { createFileRoute } from '@tanstack/react-router';
import { Layout } from '~/components/layouts/layout';
import { m } from '~/paraglide/messages.js';
import { BusinessApiKeysTable } from './-components/business-api-keys-table';
import { CreateBusinessApiKeyDrawer } from './-components/create-business-api-key-drawer';

export const Route = createFileRoute('/_authenticated/dev/business/')({
  component: BusinessApiKeysPage,
});

function BusinessApiKeysPage() {
  return (
    <Layout
      title={m['developer.business_api_keys.title']()}
      breadcrumbs={[
        { label: m['developer.menu.title'](), href: '/dev' },
        {
          label: m['developer.business_api_keys.title'](),
          href: '/dev/business',
        },
      ]}
    >
      <div className="space-y-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">
              {m['developer.business_api_keys.title']()}
            </h2>
            <p className="text-muted-foreground">
              {m['developer.business_api_keys.subtitle']()}
            </p>
          </div>
          <div className="sm:flex-shrink-0">
            <CreateBusinessApiKeyDrawer />
          </div>
        </div>

        <BusinessApiKeysTable />
      </div>
    </Layout>
  );
}
